import { Component, inject } from '@angular/core';
import { ParseRequestsStore } from '../../stores/parse-requests.store';
import { RouterLink } from '@angular/router';
import { Alert, Button, LoadingSpinner } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { ParseRequestCreatePage } from '../parse-request-create-page/parse-request-create-page';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-parse-request-create-success-page',
  imports: [RouterLink, Button, NgIcon, Alert, LoadingSpinner, TranslocoPipe],
  templateUrl: './parse-request-create-success-page.html',
})
export class ParseRequestCreateSuccessPage {
  private parseRequestsStore = inject(ParseRequestsStore);
  private parent = inject(ParseRequestCreatePage);

  protected organizationId = this.parseRequestsStore.organizationId;
  protected parseRequestId = this.parent.parseRequestId;
}
